import { tickerItems } from "@/mocks/feed";

export default function Ticker() {
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <div className="relative z-10 flex w-full items-center overflow-hidden border-y border-background-200 bg-background-100">
      <div className="flex shrink-0 items-center gap-2 bg-accent-500 px-3 py-2.5 md:px-4">
        <i className="ri-record-circle-fill animate-live text-base text-primary-700" aria-hidden="true"></i>
        <span className="text-sm font-bold text-foreground-950 whitespace-nowrap">前线快讯</span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="flex w-max animate-ticker items-center gap-10 py-2.5 pl-6">
          {doubled.map((item, idx) => (
            <span key={idx} className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700">
              <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
              {item}
            </span>
          ))}
        </div>
      </div>
      <a
        href="#feed"
        className="hidden shrink-0 items-center gap-1 border-l border-background-200 bg-background-100 px-4 py-2.5 text-sm font-medium text-primary-700 hover:text-primary-800 sm:flex whitespace-nowrap cursor-pointer"
      >
        更多 <i className="ri-arrow-right-line" aria-hidden="true"></i>
      </a>
    </div>
  );
}